import querystring from 'querystring';

export function appendQueryParams(url, queryParams) {
    const queryStringStart = url.indexOf('?');

    if (queryStringStart !== -1) {
        const query = url.slice(queryStringStart + 1);
        const originalParams = querystring.parse(query);

        const mergedParams = {
            ...originalParams,
            ...queryParams,
        };

        const newQuery = querystring.stringify(mergedParams);
        const baseUrl = url.slice(0, queryStringStart);

        return `${baseUrl}?${newQuery}`;
    } else {
        const newQuery = querystring.stringify(queryParams);

        return `${url}?${newQuery}`;
    }
}
